
let timer;

export function debounce(f, t) {

    return function (args) {
        clearTimeout(timer);
        timer = setTimeout(() => f(args), t);
    }
}